<template>
  <div class="content">
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" class="form-inline">
          <el-form-item>
            <span class="choosedep" v-if="choosedepDialog">{{choosedepDialog}}</span>
            <el-button @click="choosedep" size="medium">选择部门</el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchName" placeholder="搜索员工姓名" size="medium">
              <i slot="suffix" class="el-input__icon el-icon-search searchInput" @click="searchList"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="initList" @click="initList" size="medium">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table tooltip-effect="dark" :data="tableData" style="width: 100%">
        <el-table-column label="头像" width="180">
          <template slot-scope="scope">
            <img class="avatar" :src="scope.row.pic" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="员工" width="180"></el-table-column>
        <el-table-column prop="department" label="部门"></el-table-column>
        <el-table-column prop="position" label="职位"></el-table-column>
        <el-table-column prop="name" label="设为默认名片" width="180">
          <template slot-scope="scope">
            <el-switch
                    @change="switchChange($event,scope.$index)"
                    v-model="scope.row.switchStatus"
                    active-color="#2AA3F8"
                    inactive-color="#ddd">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="cursorCopy" @click="onCopy(scope.row.url1)" v-clipboard:error="onErrorUrl">复制名片链接</span>
            <span class="cursorCopy ml10" @click="onCopy(scope.row.url2)" v-clipboard:error="onErrorUrl">复制沟通链接</span>
            <span @click="cardEditFn(scope.row.id)" class="cardedit">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
                @current-change="pageIndexChange"></el-pagination>
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
    <applicationHintsDialog :visible.sync="applicationdialog" v-if="applicationdialog"></applicationHintsDialog>
  </div>
</template>
<script>
  import api from '@/api.js';
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import applicationHintsDialog from "@/components/dialog/applicationHintsDialog.vue";
  import {pagination} from "@/util/util.js";

  export default {
    name: "cardlist",
    components: {
      chooseDepDialog,
      applicationHintsDialog
    },
    data() {
      return {
        choosedepDialog: '',
        tableData: [],
        value: 1,
        choosedepdialog: false,
        applicationdialog: false,
        disabledBtn: false,
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        searchName: '',
        depart_id: '',
        valueCopy: 'http://www.copy.com'
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.card_index, {page: this.page.pageindex, name: this.searchName, depart_id: this.depart_id})
            .then(response => {
              // "is_default":"是否为默认名片(0否、1是)",
              if (response.data.code === 0) {
                for (let i in response.data.list) {
                  if (response.data.list[i].is_default === 1) {
                    response.data.list[i].switchStatus = true
                  } else {
                    response.data.list[i].switchStatus = false
                  }
                }
                this.tableData = response.data.list
                this.page.total = response.data.all_page
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 分页
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.InitFn();
      },
      searchList() {
        this.page.pageindex = 1;
        this.InitFn()
      },
      initList() {
        this.searchName = '';
        this.depart_id = '';
        this.page.pageindex = 1;
        this.choosedepDialog = ''
        this.InitFn()
      },
      onCopy(e) {
        this.$clipboard(e);
        this.$message.success("复制成功！");
      },
      onErrorUrl(e) {
        this.$message.success("复制失败！");
      },
      cardedit() {
        let routeData = this.$router.resolve({
          name: "cardMakeUp"
        });
        window.open(routeData.href, "_blank");
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      choosedepsucess(val) {
        // this.formdata.depart_name = val.name;
        // this.formdata.depart_id = val.id;
        this.choosedepDialog = val.name
        this.depart_id = val.id
        this.InitFn()
      },
      // 批量装修
      application() {
        this.applicationdialog = true;
      },
      // 选项
      handleSelectionChange(val) {
        if (val.length !== 0) {
          this.disabledBtn = true
        } else {
          this.disabledBtn = false
        }
      },
      // 选中取消
      switchChange(even, index) {
        this.axios
            .post(api.card_set_default, {card_id: this.tableData[index].id})
            .then(response => {
              // "is_default":"是否为默认名片(0否、1是)",
              if (response.data.code === 0) {
                this.tableData[index].switchStatus = even
                this.$message({
                  message: '设置成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      cardEditFn(e) {
        this.$router.push({name: "cardEdit", query: {id: e}});
      }
    }
  };
</script>

<style scoped>
.avatar{width: 48px; height: 48px; border-radius: 50%;}
</style>